import $ from 'jquery'

export default function video() {
  const video = $('.js-top-video')
  if (!video.length) return false

  function vedeoControl() {
    const winT = $(window).scrollTop()
    const winH = document.documentElement.clientHeight

    video.each(function () {
      const elmT = $(this).offset().top
      const elmH = $(this).height()
      const winB = winT + winH

      if (winB >= elmT && winT < elmT + elmH) {
        $(this).find('video').get(0).play()
      } else {
        $(this).find('video').get(0).pause()
      }
    })
  }

  $(window).on('scroll', function () {
    vedeoControl()
  })
}
